import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmDialog } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ShipperUninstallDialogProps {
  /** Whether the status mutation is currently in-flight. Disables the confirm button. */
  isConfirmPending: boolean;
  /** The name of the shipper being uninstalled, shown in the dialog. */
  name: string | null;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function ShipperUninstallDialog({
  isConfirmPending,
  name,
  onConfirm,
  onOpenChange,
  open,
}: ShipperUninstallDialogProps): React.JSX.Element {
  const { t } = useTranslation('settings');

  return (
    <ConfirmDialog
      cancelLabel={t('shippers.confirm.uninstall.cancel')}
      confirmLabel={
        isConfirmPending ? t('shippers.confirm.uninstall.confirming') : t('shippers.confirm.uninstall.confirm')
      }
      description={t('shippers.confirm.uninstall.description', { name: name ?? '' })}
      destructive
      isPending={isConfirmPending}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      open={open}
      title={t('shippers.confirm.uninstall.title', { name: name ?? '' })}
    />
  );
}
